import {connect} from 'react-redux';
import { findIndex } from 'lodash';
import {ResultsComparisonGel as Component} from './ResultsComparisonGel';
import {} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  return {
    gelDragDropPrediction: state.notebook.levelData.GENERIC_CHAPTERS.PREDICTIONS.components[findIndex(state.notebook.levelData.GENERIC_CHAPTERS.PREDICTIONS.components, {type: "GEL_DRAG_DROP_QUESTION"})],
    interactionProps: {
      solutions: state.notebook.protocolSection.scene.apparatus.solutions,
      thermocyclers: state.notebook.protocolSection.scene.apparatus.thermocyclers
    },
    prepareGelBox: state.notebook.protocolSection.prepareGelBox,
    runGel: state.notebook.protocolSection.runGel,
    visualizeGel: state.notebook.protocolSection.visualizeGel,
    loadDNALadder: state.notebook.protocolSection.loadDNALadder,
    runThermocycler: state.notebook.protocolSection.runThermocycler,
  }

}

function mapDispatchToProps(dispatch) {
  return {};
}

export const ResultsComparisonGel = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
